<template>
  <div>
    <transition name="modal-fade-scale">
      <app-modal
        v-if="open"
        class="popup"
      >
        <app-modal-default unpadded @close="closePopup" class="fert-popup">
          <template v-slot:header>
            <!-- TODO добавить переводы -->
            {{$ml.get('New lab')}}
          </template>
          <template v-slot:content>
            <div class="content">
              <Info :info="general.info"/>
              <LineMy />
              <Nutrients :nutTable="general.nutrients" :info="general.info"/>
              <LineMy />
            </div>
          </template>
        </app-modal-default>
      </app-modal>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Nutrients from './Nutrients.vue';
import Info from './Info.vue';
import LineMy from './helps/Line.vue';

export default {
  computed: {
    ...mapGetters({
      general: 'labs/popup/general',
      open: 'labs/popup/open',
    })
  },
  methods: {
    closePopup () {
      if (this.general.info.id) {
        this.$store.dispatch('labs/loadAllExt');
        this.$store.dispatch('labs/loadLabs').then(res => {
          this.$store.dispatch('labs/getLab', this.general.info.id);
          this.$store.dispatch('labs/getMethods', this.general.info.id);
          this.$router.push('/dashboard/labs/' + this.general.info.id);
        });
      }

      this.$store.dispatch('labs/popup/open', {open: false});
    },
    // save () {
      // this.$store.dispatch('labs/popup/save').then(res => {
      //   if (res.data.success == true) {
      //     this.$notify({
      //       group: 'notices',
      //       title: `Fertilizer successfully added!`,
      //       type : 'Success',
      //     });
  
      //     if (this.$store.getters['labs/popup/isNew']) {
      //       this.$store.dispatch('labs/getlabs').then(res_2 => {
      //         this.$router.push('/dashboard/labs/all/' + (this.$store.getters['labs/getPageCount'] - 1) + '/' + res.data.data.id);
      //       });
      //     } else {
      //       this.$store.dispatch('labs/getFertilizer');
      //     }
      //     this.closePopup();
      //   }
      // }).catch(err => {
      //   this.$notify({
      //     group: 'notices',
      //     title: `An error occurred`,
      //     type : 'Error',
      //   });
      // });
    // },
  },
  components: {
    Nutrients,
    LineMy,
    Info
  }
}
</script>

<style lang="scss" scoped>
.popup {
  width: 100%;

  .fert-popup {
    width: 90vw;

    .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 14px;
      padding-bottom: 40px;
      box-sizing: border-box;

      .save-button {
        width: 166px;
      }
    }
  }
}
</style>